<template>
  <div class="11112222333" @click="clickDiv">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App',
    beforeUpdate() {
      this.clickDiv()
    },
    methods: {
      clickDiv() {
        clearInterval(this.timeIN)
        this.timeOut = 0
        console.log('当前路径=', this.$route.path)
        //等保三级
        // if (this.$route.path == '/') {
        //   return
        // }        this.timeIN = setInterval(() => {
        //   if (this.timeOut >= 1800) {
        //     clearInterval(this.timeIN)
        //     this.timeOut = 0
        //     this.logout()
        //   } else {
        //     this.timeOut = this.timeOut + 1
        //   }
        // console.log('clickDiv',this.timeOut)
        // }, 1000);
      },
      logout() {
        sessionStorage.clear();
        this.$confirm('由于长时间未进行操作，请重新登录。', '提示', {
          confirmButtonText: '确定',
          showCancelButton: false,
          closeOnClickModal: false, showClose: false,
          type: 'warning'
        }).then(() => {
          clearInterval(this.runCount);
          this.$router.push("/");
        }).catch(() => { });
      },
    }
  }

</script>

<style>
  ::-webkit-scrollbar {
    width: 7px;
    height: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #e0e5f1;
    border-radius: 3px;
  }
</style>


// WEBPACK FOOTER //
// src/App.vue